var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 14.6667C10.6667 12 13.3333 9.61223 13.3333 6.66671C13.3333 3.72119 10.9455 1.33337 7.99999 1.33337C5.05447 1.33337 2.66666 3.72119 2.66666 6.66671C2.66666 9.61223 5.33332 12 7.99999 14.6667Z",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 8.33333V4.66667C7.33334 4.29848 7.63182 4 8.00001 4C8.3682 4 8.66668 4.29848 8.66668 4.66667V8.33333C8.66668 8.70152 8.3682 9 8.00001 9C7.63182 9 7.33334 8.70152 7.33334 8.33333Z",
    fill: "#D92D20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66668 10.6667C8.66668 11.0349 8.3682 11.3333 8.00001 11.3333C7.63182 11.3333 7.33334 11.0349 7.33334 10.6667C7.33334 10.2985 7.63182 10 8.00001 10C8.3682 10 8.66668 10.2985 8.66668 10.6667Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLocation);
export default __webpack_public_path__ + "static/media/alert-location.8b80f04a734612063f9a07c0dbb6807f.svg";
export { ForwardRef as ReactComponent };